/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Value/view.blocks to change it.
import * as fromData from 'Simple/Data'
import React from 'react'
import TysiaInput from 'DesignSystem/TysiaInput/index'
import TysiaInputContent from 'DesignSystem/TysiaInput/TysiaInputContent/index'
import TysiaInputField from 'DesignSystem/TysiaInput/TysiaInputField/index'



/** @type {import('Simple/types.js').View} */
export default function Value({
  children,
  viewPath = "/DesignSystem/EditAutomation/EventActions/Content/EventAction/Wait/Content/Time/Value",
  onChange
  
}) {
let selectedValueValueData = fromData.useDataValue({ viewPath,
context: 'selected',
path: 'value',
})
let selectedValueChangeData = fromData.useDataChange({ viewPath,
context: 'selected',
path: 'value',
})
  return (<React.Fragment
>
<TysiaInput
  viewPath={`${viewPath}/TysiaInput`}
 type="number"
 disabled={true}
 data="selected.value"
 value={selectedValueValueData}
 onChange={selectedValueChangeData}
 marginTop={0}
 maxWidth={40}
>
{childProps => (
<TysiaInputContent
{...childProps}
  viewPath={`${viewPath}/TysiaInputContent`}
>
{childProps => (
<TysiaInputField
{...childProps}
  viewPath={`${viewPath}/TysiaInputField`}
/>
)}
</TysiaInputContent>
)}
</TysiaInput>
{children}
</React.Fragment>)
}